export const fileBrowser = (callback, value, meta, currentEditor) => {
  const type = meta.filetype
  let cmsURL = `/admin/manager/?conf=tiny_${type}&module=tiny&type=${type}`
  if (cmsURL.indexOf('?') < 0) {
    cmsURL = `${cmsURL}?type=${type}`
  }
  const windowManagerCSS = '<style type="text/css">' + '.tox-dialog {max-width: 100% !important; width:97.5% !important; overflow: hidden; height:95% !important; border-radius:0.25em;}' + '.tox-dialog__body {padding: 0 !important; }' + '.tox-dialog__body-content > div {height: 100%; overflow:hidden} .tox-form__group{height: 100% !important}' + '</style > '
  window.tinymceCallBackURL = ''
  window.tinymceWindowManager = currentEditor.windowManager
  window.tinymceWindowManager.open({
    title: 'File Manager',
    body: {
      type: 'panel',
      items: [
        {
          type: 'htmlpanel',
          html: windowManagerCSS + '<iframe src="' + cmsURL + '" frameborder="0" style="width:100%; height:100%"></iframe>'
        }
      ]
    },
    buttons: [],
    onClose: function () {
      if (window.tinymceCallBackURL !== '') {
        callback(window.tinymceCallBackURL, {})
      }
    }
  })
}
